import React, { useContext, useEffect, useState } from "react";
import { backIncstance, formatDateString, formatToKoreanWon, getLoginInfo } from "../../utils/commonFunctions";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../context/MyContext";
import Paging from "../../components/Paging";
import styled from "styled-components";

const URLS = {
  GET_ORDER_LIST: process.env.REACT_APP_MYPAGE_GET_ORDER_LIST,
  GENERATE_ORDER: process.env.REACT_APP_MYPAGE_GENERATE_ORDER_LIST,
  CHECK_CANCEL: process.env.REACT_APP_MYPAGE_CEHCK_CANCEL_ORDER,
  CANCEL_ORDER: process.env.REACT_APP_MYPAGE_CANCEL_ORDER,
  HELP: process.env.REACT_APP_DONGA_INQUERY,
}

const NONE_PAID = `과학동아AiR PASS를 구매하시고,\n 자유롭게 이용하세요! 🙌`;

const Order = props => {

  const { user, isMobile, setAlertSetting, clearState, setIsLogin } = useContext(MyContext);

  const [orderList, setOrderList] = useState([])
  const [pageInfo, setPageInfo] = useState({
    offset: 1,
    limit: 10,
    total: 0,
  })

  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data)

      if (response.status === 401) {
        setAlertSetting(prev => ({
          ...prev,
          alertTxt: '잠시 후 다시 시도해주세요.'
        }))
      } else {
        return response
      }

    } catch (err) {
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: '잠시 후 다시 시도해주세요.'
      }))
    } finally {

    }

  }

  const [refund, setRefund] = useState({
    is_refundable: true,
    refund_amount: 1000,
    paid_amount: 2000
  })

  // const checkIfCancel = async item => {

  //   const checkResponse = await touchAPI('GET', URLS.CHECK_CANCEL, `?order_no=${item.order_no}`)
  //   if (checkResponse) {
  //     const checkData = await checkResponse.json();
  //     if (checkData.is_refundable) {
  //       setRefund(checkData)
  //       confirmCacnel(item)
  //     } else {
  //       setAlertSetting(prev => ({
  //         ...prev,
  //         alertTxt: `환불 가능한 주문이 아닙니다.\n 고객센터에 문의해주세요.`,
  //         btnTxt: '닫기'
  //       }))
  //     }
  //   }

  // }
  const checkIfCancel = async item => {

    setAlertSetting(prev => ({
      ...prev,
      alertTxt: `고객센터(1:1) 문의를 통해 신청해 주세요.`,
      btnTxt: '이동하기',
      double: true,
      onConfirm: () => {
        if (typeof prev.onConfirm === 'function') {
          prev.onConfirm()
        }
        window.open(URLS.HELP, '_blank')
      }
    }))

  }
  const handleCancel = async item => {
    clearState();
    const reqData = {
      order_no: item.order_no
    }
    const response = await touchAPI('PUT', URLS.CANCEL_ORDER, reqData)
    if (response) {
      const resData = await response.json();
      let text = '다시 시도해주세요.'
      if (resData.code === 200) {
        text = '취소가 완료되었습니다.'
      }
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: text,
        btnTxt: '닫기',
      }))
      getData()
    }
  }

  const confirmCacnel = item => {
    setAlertSetting(prev => ({
      ...prev,
      alertTxt: '결제를 취소하시겠습니까?',
      btnTxt: '결제 취소하기',
      double: true,
      onConfirm: () => {
        if (typeof prev.onConfirm === 'function') {
          prev.onConfirm()
        }
        handleCancel(item)
      }
    }))
  }

  const navigation = useNavigate()

  const linkToPage = path => {
    navigation(path)
  }
  const getData = async () => {

    if (user.id) {
      try {
        const url = `${URLS.GET_ORDER_LIST}?offset=${pageInfo.offset}&limit=${pageInfo.limit}`
        const resData = await touchAPI('GET', url);
        if (resData) {
          const data = await resData.json();
          setOrderList(data.order_list);
          setPageInfo((prev) => ({
            ...prev,
            total: data.total_count,
          }));
        }
      } catch (error) {
        setAlertSetting(prev => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: '닫기'
        }));
      }
    }
  }
  useEffect(() => {
    const loginInfo = getLoginInfo();
    if (!loginInfo.id) {
      setIsLogin(true)
      return
    }
    getData();
  }, [user.id, pageInfo.offset, pageInfo.total])
  return (
    <Style>
      <div className="ctn-wrp flx-box st-wrp order-list">
        <div className="order-list__title setting-title">
          <p>구매내역</p>
        </div>
        {
          user.paid
            ?
            <div className="order-list__wrapper top flx-box sep-elm">
              <div className="left flx-box">🙎‍♂️<p className="bold-txt">{user.name ? user.name : '사용자'}</p>님의 이용기간</div>
              <div className="right">
                {
                  `${formatDateString(user.start_dt)} ~ ${formatDateString(user.end_dt)}`
                }
              </div>
            </div>
            :
            <div className="order-list__wrapper top flx-box sep-elm">
              <div className="left">
                <div className="flx-box">
                  <p className="bold-txt">과학동아AiR PASS</p>를 구매하시고,
                </div>
                <div className="break flx-box"><p className="bold-txt">자유롭게 이용</p>하세요!</div>
              </div>
              <div className="right crs-btn" onClick={() => linkToPage('/settings/products')}>
                <p>PASS 구매하기</p>
              </div>
            </div>
        }
        <div className="order-list__wrapper bottom" style={{ padding: 0 }}>
          <table className="my-items">
            <thead>
              <tr>
                {
                  !isMobile &&
                  <>
                    <th className="bright-txt">주문번호</th>
                    <th>결제일시</th>
                  </>
                }
                <th>상품정보</th>
                <th>결제금액</th>
                <th>결제상태</th>
              </tr>
            </thead>
            <tbody>
              {
                orderList?.length > 0 ?
                  orderList.map(item => {
                    return (
                      <tr key={`${item.order_no}-${item.is_canceled}`}>
                        {
                          !isMobile &&
                          <>
                            <td>{item.order_no}</td>
                            <td>{item.created_at ? formatDateString(item.created_at) : null}</td>
                          </>
                        }
                        <td className="center">{item.item_name}</td>
                        <td>{formatToKoreanWon(item.order_price)}원</td>
                        <td className="item-status">
                          <div className="btn-wro">
                            <p>{item.is_canceled ? '취소완료' : '결제완료'}</p>{(!item.is_canceled) ? <button onClick={() => checkIfCancel(item)}>결제취소</button> : null}
                          </div>
                        </td>
                      </tr>
                    )
                  })
                  :
                  <tr>
                    <td className="empty-list" colSpan={5}>내역이 없습니다.</td>
                  </tr>
              }
            </tbody>
          </table>

          {
            (pageInfo.total > 0) &&
            <Paging pageInfo={pageInfo} setPageInfo={setPageInfo} />
          }
          {
            isMobile &&
            <p className="mobile-inform">* 상세한 구매내력을 확인하시려면 PC로 접속해주세요.</p>
          }
        </div>
      </div>
    </Style>
  )
}
export default Order;


const Style = styled.div`
@media screen and (min-width: 1024px) {
     height: 100%;
}
@media screen and (min-width: 768.99px) and (max-width: 1023.99px) {
    height: 100%;

}
    @media screen and (max-width: 768.98px) {
    height: calc(100% - 120px);

}
`
